import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useChargebeePortals } from "hooks/useChargebeePortals";

import { useChargebee } from "providers/ChargebeeProvider";


export function AutoOpenBillingAddressDialog() {
  const { openChargebeePortal } = useChargebeePortals();
  const { chargebeeInstance } = useChargebee();
  const navigate = useNavigate();

  useEffect(() => {
    if (chargebeeInstance) {
      openChargebeePortal("ADDRESS", { close: () => navigate("/billing") });
    }
  }, [ chargebeeInstance, openChargebeePortal, navigate ]);

  return <></>;
}
